import classNames from 'classnames';
import styles from './Collection.module.css';
import { canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { CollectionsElement } from '../CollectionsElement/CollectionsElement';
import Tippy from "@tippyjs/react";
import { collectionsContext, TCollectionsDataItem } from "../../../context/collectionsContext";
import { canvasTextureContext } from "../../../context/canvasTextureContext";

interface TCollectionsElement {
    id: number;
    img: string;
    name: string;
    currentSectionId: number;
    onCollectionChange: () => void;
    isLocked: boolean;
    items: TCollectionsDataItem[];
}

// export type TCollectionsDataItem = {
//     id: number;
//     img: string;
//     name: string;
// };

interface IOptionTooltipContentProps {
    content: string;
}

export const Collection = (element: TCollectionsElement) => {
    const {
        id, img, name, items, currentSectionId, onCollectionChange, isLocked
    } = element;

    const [isOpenPopover, setOpenPopover] = useState(false);
    const isMobile = window.innerWidth < 991;
    const isColorPicker = +id === 1607;
    const collectionRef = useRef<HTMLDivElement>(null);
    const colorPickerRef = useRef<HTMLDivElement>(null);
    const closePopoverRef = useRef<HTMLDivElement>(null);
    const [isColorPickerOpen, setIsColorPickerOpen] = useState<boolean>(false);
    const { collectionsData, setCollectionsData } = useContext(collectionsContext);
    const { imgData } = useContext(canvasTextureContext);
    // const texture = imgData.items.find((item: any) => item.img == imgData.img)?.id;
    const handlePopoverOpen = () => {
        setOpenPopover(true);
    };

    const handlePopoverClose = () => {
        if(isOpenPopover) {
            setOpenPopover(false);
        }
    };

    useEffect(() => {
        function handleClick(event: MouseEvent) {
            event.stopPropagation();
            if(isOpenPopover && event.target instanceof Node && !collectionRef.current?.contains(event.target)) {
                handlePopoverClose();
            }

            if(isColorPicker
                && event.target instanceof Node && !colorPickerRef.current?.contains(event.target)
                && event.target instanceof Node && !collectionRef.current?.contains(event.target)
            ) {
                setIsColorPickerOpen(false);
            }

            if(isColorPicker && event.target instanceof Node && closePopoverRef.current?.contains(event.target)) {
                setIsColorPickerOpen(false);
            }
        }

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        }
    }, [isOpenPopover]);


    const handleChangeCollection = () => {
        if(isLocked) return;
        const curSectionData = JSON.parse(localStorage!.getItem(`sectionData_${id}`)!);

        const elementId = curSectionData && curSectionData.elementId
            ? curSectionData.elementId
            : collectionsData.sectionId == id && collectionsData.elementId
                ? collectionsData.elementId
                : items[0].id
        ;

        const newSectionData = {
            sectionId: id,
            elementId: elementId,
            // texture: curSectionData?.texture ? curSectionData.texture : texture
            texture: curSectionData?.texture ? curSectionData.texture : null
        }

        localStorage.setItem(`sectionData_${id}`, JSON.stringify(newSectionData));
        setCollectionsData({
            ...collectionsData,
            elementId: elementId,
            sectionId: id,
            prevSectionId: collectionsData.sectionId
        });
        onCollectionChange();
    }

    return (
        <>
            <Box ref={collectionRef} className={classNames(styles.elementBox, isLocked && styles.locked)}>
                <div className={styles.elementBoxCustom}>
                    <div className={classNames(styles.container, styles.textureContainer)}>
                        <div
                            className={classNames(styles.imageWrap, currentSectionId == id && styles.imageWrapSelected)}>
                            <div className={classNames(styles.imageContainer, styles.textureImageContainer)}>
                                <div className={classNames(styles.name)}>{name}</div>
                                <img src={'https://fresq.ru/' + img}
                                     alt={name}
                                     className={classNames('collection_image')}
                                     onClick={() => {
                                         handleChangeCollection();
                                     }}
                                />
                            </div>
                        </div>

                    </div>
                    {isColorPicker && isColorPickerOpen && (
                        <div className={classNames(styles.colorPickerContainer)}>
                            <div ref={closePopoverRef} className={classNames(styles.colorPickerCloseButton)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 5L5 19M5 5L9.5 9.5M12 12L19 19" stroke="#000000" strokeWidth="1.5"
                                          strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </div>

                        </div>
                    )}
                    <div className={classNames(styles.toggleWrapper)}>
                        {isMobile && (
                            <div className={classNames(styles.popupToggle)}
                                 onClick={handlePopoverOpen}
                            >
                                Выбрать
                            </div>
                        )}
                        {!isMobile && (
                            <div className={classNames(styles.popupToggleBottom)}
                                 onClick={handlePopoverOpen}
                            >
                                Выбрать
                                <Tippy
                                    className={styles.info}
                                    content={<OptionTooltipContent content={'Выберите коллекцию'}/>}
                                    interactive={true}
                                    interactiveBorder={20}
                                    delay={100}
                                    duration={100}
                                    animation={'scale'}
                                    allowHTML={true}
                                >
                                    <svg width="20" height="20" viewBox="0 0 227 227" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.30005 64.5C2.30005 62 3.30005 59.4 5.20005 57.5C9.10005 53.6 15.4001 53.6 19.2001 57.5L113.4 151.7L207.6 57.5C211.5 53.6 217.8 53.6 221.6 57.5C225.5 61.4 225.5 67.7 221.6 71.5L126.2 166.9C122.8 170.3 118.2 172.2 113.3 172.2C108.4 172.2 103.9 170.3 100.4 166.9L5.00005 71.5C3.20005 69.6 2.30005 67 2.30005 64.5Z"
                                            fill="#FF5100"/>
                                    </svg>
                                </Tippy>
                            </div>
                        )}
                    </div>
                </div>
            </Box>

            {isOpenPopover && (
                <div
                    className={classNames(styles.popover)}
                    onClick={event => event.stopPropagation()}
                >
                    <div className={classNames(styles.close)} onClick={handlePopoverClose}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 5L5 19M5 5L9.5 9.5M12 12L19 19" stroke="#000000" strokeWidth="1.5"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <CollectionsElement
                        sectionId={id}
                        sectionName={name}
                        items={items}
                    />
                </div>
            )}


            {/*{selected && (*/}
            {/*    <div className={'hidden'}>*/}
            {/*        <div id={'js-background-name'}>{selectedBackgroundName}</div>*/}
            {/*        <div id={'js-background-group-name'}>{name}</div>*/}
            {/*    </div>*/}
            {/*)}*/}

        </>
    );
};

const OptionTooltipContent = ({ content }: IOptionTooltipContentProps) => {
    return <div className={styles.tooltipContent} dangerouslySetInnerHTML={{ __html: content }}/>;
};